import { ManagedFile } from '../../helperts/file.helper';

export type UploadStatus = 'pending' | 'in-progress' | 'success' | 'error';

/**
 * Represents the state of a single file upload.
 */
export interface Upload {
  id: string; // Corresponds to ManagedFile.metadata.id
  file: ManagedFile;
  progress: number; // Percentage from 0 to 100
  status: UploadStatus;
  error?: unknown;
}

/**
 * Represents the state for all file uploads, indexed by the upload ID.
 */
export interface UploadState {
  uploads: { [id: string]: Upload };
}

export const initialState: UploadState = {
  uploads: {},
};
